/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function wc(_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.events, events = _b === void 0 ? {} : _b, ref = _a.ref, props = __rest(_a, ["events", "ref"]);
    if (typeof window === 'undefined')
        return;
    var eventMap = new Map();
    return function (node) {
        Object.entries(events).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            var currentHandler = eventMap.get(name);
            if (!node) {
                document.removeEventListener(name, currentHandler, {
                    passive: true,
                });
                eventMap.delete(name);
                return;
            }
            function newHandler(event) {
                if (event.target === node && typeof value === 'function') {
                    value(event);
                }
                return false;
            }
            if (currentHandler) {
                document.removeEventListener(name, currentHandler, {
                    passive: true,
                });
            }
            document.addEventListener(name, newHandler, { passive: true });
            eventMap.set(name, newHandler);
        });
        if (node) {
            Object.entries(props).forEach(function (_a) {
                var name = _a[0], value = _a[1];
                node[name] = value;
            });
        }
        if (ref) {
            ref(node);
        }
    };
}

export { wc };
